module.exports = __webpack_public_path__ + "static/king-0ec16f30ff40a561c4d6bf7338b2d5b9.png";